import React from "react";
import "./Loader.css";
import loaderGif from "../Assets/Loader.gif";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <img src={loaderGif} alt="loading..." className="gif-loader" />
    </div>
  );
};

export default Loader;
